import { getRouteApi, useNavigate } from '@tanstack/react-router'
import CantileverButton, { AddButton } from 'components/CantileverButton'
import { PageHeader } from 'components/PageHeader'
import { AssetOverviewAdminGate } from 'features/assetDatabase/components/gates/AssetOverviewGates'
import { useHasAssetLensData } from 'features/assetDatabase/hooks/useHasAssetLensData'
import { DrawerState, useRightDrawer } from 'features/rightDrawer'
import { Lightbulb, List } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'
import { GeckoUnit } from 'types'

const ButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

const StyledLightbulb = styled(Lightbulb)`
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
`

interface DetailsHeaderProps {
  noAssetModel: boolean
  unit: GeckoUnit | undefined
  refreshData: () => Promise<void>
}

const DetailsHeader: React.FC<DetailsHeaderProps> = (props) => {
  const { noAssetModel, unit, refreshData } = props
  const { setDrawerState, setDrawerEntry, setOnDrawerClose } = useRightDrawer()
  const navigate = useNavigate()

  // Get route params for the AssetLens link
  const { useParams } = getRouteApi('/assets/$siteID/$unitID')
  const { siteID, unitID } = useParams()

  // Check if asset-lens data exists
  const { hasData: hasAssetLensData } = useHasAssetLensData(unitID)

  const handleOpenAssetLens = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    navigate({
      to: '/asset-lens/$siteID/$unitID',
      params: { siteID, unitID },
    })
  }

  return (
    <PageHeader
      title='Details'
      icon={<List />}
      trailingContent={
        <ButtonContainer>
          {/* AssetLens Button - only show if data exists */}
          {hasAssetLensData && (
            <CantileverButton onClick={handleOpenAssetLens}>
              <StyledLightbulb />
              Open in Asset Lens
            </CantileverButton>
          )}

          {noAssetModel && (
            <AssetOverviewAdminGate>
              <AddButton
                entityName='Rich Asset Model'
                onClick={() => {
                  setDrawerEntry(unit)
                  setDrawerState(DrawerState.EditGeckoComponent)
                  setOnDrawerClose(() => refreshData)
                }}
              />
            </AssetOverviewAdminGate>
          )}
        </ButtonContainer>
      }
    />
  )
}

export default DetailsHeader
